import { User, LoggedInUser } from '../types';

export function isLoggedInUser(user: User): user is LoggedInUser {
    return user?.__typename === 'Me';
}
